import { render, staticRenderFns } from "./DetailsParamsInfo.vue?vue&type=template&id=7f108494&scoped=true&"
import script from "./DetailsParamsInfo.vue?vue&type=script&lang=js&"
export * from "./DetailsParamsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailsParamsInfo.vue?vue&type=style&index=0&id=7f108494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f108494",
  null
  
)

export default component.exports